export default {
  IsEnabled: false,
  FirstName: "",
  LastName: "",
  BirthDate: null,
  SalesPersonCode: null,
  CompanySelected: "",
  FullName: "",
  Email: "",
  EmailConfirmed: false,
  PasswordHash: "",
  SecurityStamp: "",
  PhoneNumber: null,
  PhoneNumberConfirmed: false,
  TwoFactorEnabled: false,
  LockoutEndDateUtc: null,
  LockoutEnabled: false,
  AccessFailedCount: 0,
  Roles: [],
  Claims: [],
  Logins: [],
  Id: 0,
  UserName: ""
};
